import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

type TSliderProps = {
    isSlider: true,
    slideWidth: number,
    slideHeight: number,
    cellSpacing?: number,
} | {
    isSlider: false,
    slideWidth?: never,
    slideHeight?: never,
    cellSpacing?: never,
}

export const useSlider = (): TSliderProps => {
    const isLaptop = useMatchMediaByWidth(wideBreakpoints.laptop);
    const isTablet = useMatchMediaByWidth(wideBreakpoints.tablet);
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    switch (true) {
        case isLaptop && !isTablet:
            return {
                isSlider: true,
                slideWidth: 264,
                slideHeight: 168,
                cellSpacing: 8,
            };
        case isMobile:
            return {
                isSlider: true,
                slideWidth: 190,
                slideHeight: 126,
            };
        case isTablet:
        default:
            return {
                isSlider: false,
            };
    }
};
